import FetchPreviewUrlRequest from './types/FetchPreviewUrlRequest';
import { OWA_ROOT_PREFIX } from './utils/constants';

export {
    default as getAttachmentUrl,
    getAttachmentUrlForClassic,
    getAttachmentUrlForCloudy,
    getPreviewUrlRequest,
} from './utils/getAttachmentUrl';

export { FetchPreviewUrlRequest, OWA_ROOT_PREFIX };
